import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { convertValueDBToUI, resolveValueDisplay, valueType_Enumerated, valueType_SubEnumerated, valueType_Time } from '@app/hcs-shared/core';
import { ModuleFE_Value, } from '../../../../_entity.js';
import { arrayToMap, dbObjectToId, Filter, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
export class SubEnumeratedEditor extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        const allValues = ModuleFE_Value.cache.all();
        const valuesMap = arrayToMap(allValues, dbObjectToId);
        const parentValue = ModuleFE_Value.cache.unique(nextProps.value.data?.parentId);
        if (!parentValue)
            throw new MUSTNeverHappenException(`Could not find parent value with id ${nextProps.value.data?.parentId} for value with id ${nextProps.value._id}`);
        const scope = this.getValueScope(parentValue);
        //Convert all values under the scope of the parent value to UI_Values
        state.allPossibleValues = ModuleFE_Value.cache
            .filter(value => scope.includes(value._id))
            .map(value => convertValueDBToUI(value, { values: valuesMap, measurementUnits: {} }));
        return state;
    }
    // ######################## Logic ########################
    addExistingInnerValue = (innerValue) => {
        if (!innerValue)
            return;
        this.props.value.data.scope.push(innerValue);
        this.forceUpdate();
    };
    removeInnerValue = (innerValue) => {
        this.props.value.data.scope = this.props.value.data.scope.filter(item => item !== innerValue);
        this.forceUpdate();
    };
    getValueScope(value) {
        switch (value.type) {
            case valueType_SubEnumerated:
            case valueType_Enumerated:
                return value.data.scope;
            case valueType_Time:
                return value.data.timeRanges;
            default:
                return [];
        }
    }
    // ######################## Render ########################
    render() {
        return _jsx("div", { className: 'sub-enumerated-editor', children: _jsx(LL_V_L, { className: 'dialog__main__section', children: this.renderValues() }) });
    }
    renderValues = () => {
        const values = this.props.value.data?.scope ?? [];
        sortArray(values, value => value.data?.value);
        //Create dropdown props
        const valueIds = values.map(value => value._id);
        const possibleValues = this.state.allPossibleValues.filter(value => !valueIds.includes(value._id));
        const adapter = SimpleListAdapter(possibleValues, node => _jsx("div", { className: 'node-data', children: resolveValueDisplay(node.item) }));
        const filter = new Filter(item => [item.data.value]);
        return _jsx(LL_V_L, { children: _jsxs(LL_H_C, { className: 'inner-values', children: [values.map(value => {
                        const className = _className('inner-value', value._id ? 'existing' : undefined);
                        return _jsxs("div", { className: className, children: [_jsx(Button, { onClick: () => this.removeInnerValue(value), children: _jsx(ICONS.x.component, {}) }), _jsx("span", { children: value.data.value })] }, value.data.value);
                    }), _jsx(TS_DropDown, { adapter: adapter, selected: undefined, onSelected: this.addExistingInnerValue, filter: filter, tabIndex: 0, placeholder: 'Select Value', boundingParentSelector: '.dialog__main' })] }) });
    };
}
//# sourceMappingURL=SubEnumeratedEditor.js.map